import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { useBreadcrumb } from '../context/BreadcrumbContext';
import './Breadcrumbs.css';

const routeNames = {
    'noticias': 'Noticias',
    'cursos': 'Cursos',
    'admision': 'Admisión',
    'nosotros': 'Nosotros',
    'login': 'Iniciar Sesión',
    'contacto': 'Contacto',
    'backoffice': 'Backoffice',
    'noticia': 'Noticia',
    'curso': 'Curso',
    'login-emp': 'Portal Empresa',
    'login-doc': 'Portal Docente',
    'login-est': 'Portal Estudiante',
    'portal': 'Portal Estudiante',
    'portal-emp': 'Portal Empresa',
    'portal-doc': 'Portal Docente',
    'perfil': 'Perfil',
    'academico': 'Académico',
    'estudiantes': 'Mis Estudiantes',
    'matricula': 'Matrícula'
};

const Breadcrumbs = () => {
    const location = useLocation();
    const { dynamicTitle } = useBreadcrumb();
    const pathnames = location.pathname.split('/').filter(x => x);

    // Ocultar en el Home
    if (pathnames.length === 0) return null;

    return (
        <div className="breadcrumbs-container">
            <div className="breadcrumbs-inner">
                <Link to="/" className="breadcrumb-link">Inicio</Link>
                {pathnames.map((value, index) => {
                    let segmentForUrl = value;
                    if (segmentForUrl === 'noticia') segmentForUrl = 'noticias';
                    if (segmentForUrl === 'curso') segmentForUrl = 'cursos';

                    const to = `/${pathnames.slice(0, index).concat(segmentForUrl).join('/')}`;
                    const isLast = index === pathnames.length - 1;
                    
                    // Asegurarnos de que el texto también diga "Noticias" y "Cursos"
                    let title = routeNames[value] || decodeURIComponent(value);
                    if (value === 'noticia') title = 'Noticias';
                    if (value === 'curso') title = 'Cursos';
                    
                    // Reemplazar por título dinámico si es el último y existe
                    if (isLast && dynamicTitle) {
                        title = dynamicTitle;
                    }

                    const cleanTitle = typeof title === 'string' 
                        ? title.replace(/\//g, '').replace(/-/g, ' ').trim() 
                        : title;

                    return (
                        <span key={to} className="breadcrumb-item">
                            <span className="breadcrumb-separator"> 
                                <i className="ri-arrow-right-s-line"></i> 
                            </span>
                            {isLast ? (
                                <span className="breadcrumb-active">{cleanTitle}</span>
                            ) : (
                                <Link to={to} className="breadcrumb-link">{cleanTitle}</Link>
                            )}
                        </span>
                    );
                })}
            </div>
        </div>
    );
};

export default Breadcrumbs;
